import { Component } from '@angular/core';
import { RootMixin, WithMenubarMixin } from '@fapp/mixins';

@Component({
  selector: 'app-user-layout',
  templateUrl: './user-layout.component.html',
  styleUrl: './user-layout.component.scss',
  standalone: false,
})
export class UserLayoutComponent extends WithMenubarMixin(RootMixin) {
  constructor() {
    super();
  }
}
